import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PropTypes from "prop-types";
import DownloadIcon from "../../Images/DownloadIcon";

const ModalActionsKebab = ({
  failed,
  complete,
  downloadAction,
  disabled,
  account,
  dag,
  report,
  execution,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <Dropdown
      disabled={disabled}
      className={disabled ? "actionsKebab__disabled" : "actionsKebab"}
      isOpen={dropdownOpen}
      toggle={toggle}
      setActiveFromChild
    >
      <DropdownToggle tabIndex="0" caret={false}>
        <svg
          width="5"
          height="17"
          viewBox="0 0 5 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.62746 4.34758C3.69337 4.34758 4.56547 3.45155 4.56547 2.35641C4.56547 1.26126 3.69337 0.365234 2.62746 0.365234C1.56156 0.365234 0.689453 1.26126 0.689453 2.35641C0.689453 3.45155 1.56156 4.34758 2.62746 4.34758ZM2.62746 6.33875C1.56156 6.33875 0.689453 7.23478 0.689453 8.32992C0.689453 9.42507 1.56156 10.3211 2.62746 10.3211C3.69337 10.3211 4.56547 9.42507 4.56547 8.32992C4.56547 7.23478 3.69337 6.33875 2.62746 6.33875ZM2.62746 12.3123C1.56156 12.3123 0.689453 13.2083 0.689453 14.3034C0.689453 15.3986 1.56156 16.2946 2.62746 16.2946C3.69337 16.2946 4.56547 15.3986 4.56547 14.3034C4.56547 13.2083 3.69337 12.3123 2.62746 12.3123Z"
            fill="#007DB8"
          />
        </svg>
      </DropdownToggle>
      <DropdownMenu>
        {failed && (
          <DropdownItem disabled>
            <ViewErrorDetailsIcon />
            View Error Details
          </DropdownItem>
        )}
        {complete && (
          <DropdownItem
            onClick={() => downloadAction(account, dag, report, execution)}
          >
            <DownloadIcon />
            Download This Run
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

ModalActionsKebab.propTypes = {
  failed: PropTypes.bool,
  complete: PropTypes.bool,
  downloadAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  account: PropTypes.string.isRequired,
  dag: PropTypes.string.isRequired,
  report: PropTypes.string.isRequired,
  execution: PropTypes.string.isRequired,
};

ModalActionsKebab.defaultProps = {
  failed: false,
  complete: false,
  disabled: false,
};

export default ModalActionsKebab;

const ViewErrorDetailsIcon = () => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C6 0 1.73 3.11 0 7.5C1.73 11.89 6 15 11 15C16 15 20.27 11.89 22 7.5C20.27 3.11 16 0 11 0ZM11 12.5C8.24 12.5 6 10.26 6 7.5C6 4.74 8.24 2.5 11 2.5C13.76 2.5 16 4.74 16 7.5C16 10.26 13.76 12.5 11 12.5ZM11 4.5C9.34 4.5 8 5.84 8 7.5C8 9.16 9.34 10.5 11 10.5C12.66 10.5 14 9.16 14 7.5C14 5.84 12.66 4.5 11 4.5Z"
        fill="#0B78D0"
      />
    </svg>
  );
};
